import { T, Translate } from '../../i18n/index';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles, assetURL } from '../theme';

export interface ImportButtonCtx {
	disabled?: boolean;
	title?: T;
	onclick?: (a?) => void;
}

export const CSS = {
	container: 'c-Import-Poleforeman-Button',
	MDL: {
		container: 'mdl-button mdl-button--icon',
	},
};

addStyles({
	[CSS.container]: {
		position: 'fixed',
		bottom: '240px',
		right: '7.7%',
		'z-index': 5,
		width: '64px',
		height: '64px',
		'background-image': assetURL('/images/poleforeman_logo.svg'),
		'background-size': '100%',
		'background-repeat': 'no-repeat',
		'background-position': 'center',
	},
});

export const ImportPoleforemanButton = {
	view(ctx: ImportButtonCtx = {}): MithrilVNode {
		return m('button', {
			className: `${CSS.container} ${CSS.MDL.container}`,
			disabled: ctx.disabled,
			title: Translate(ctx.title),
			onclick: ctx.onclick,
		});
	},
};
